import '@/assets/styles/components/loading-spinner.styles.scss';
import { LoadingSpinnerProps } from './loading-spinner.types.ts';
import { purify } from '@/utility';

const LoadingSpinner = ({ loadingText }: LoadingSpinnerProps) => (
	<div className="spinner-wrapper">
		<div className="spinner"></div>
		<div
			className="loading-text"
			dangerouslySetInnerHTML={purify(loadingText)}
		/>
	</div>
);

export default LoadingSpinner;
